import { ProductCategory } from 'global-constants';
import { ProductCategoryDto } from 'services/openapi/apiSchemas';

export const isProductCategory = (
  productCategory: ProductCategoryDto | undefined,
  categoryToCheck: ProductCategory
) => {
  return productCategory?.name.includes(categoryToCheck);
};
